import { http } from '..';
import type { Comment } from './types';

export const fetchAll = async (projectId: string, requestId: string): Promise<Comment[]> => {
  return http.get(`/admin/projects/${projectId}/requests/${requestId}/comments`).json();
};

export const deleteComment = async (requestId: string, commentId: string) => {
  return http.url(`/admin/requests/${requestId}/comments/${commentId}`).delete().res();
};

export const updateComment = async (
  requestId: string,
  commentId: string,
  data: { text?: string; visible?: boolean },
) => {
  return http.url(`/admin/requests/${requestId}/comments/${commentId}`).put(data).res();
};
